import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { DynamicEvent } from 'src/app/main/dynamic/dynamic.event';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';

@Component({
  selector: 'app-input-text-checkbox',
  templateUrl: './input-text-checkbox.component.html',
  styleUrls: ['./input-text-checkbox.component.scss']
})
export class InputTextCheckboxComponent extends ComponentBase implements OnInit {

  checkDisabled:boolean

  constructor() { super()}

  get errorSign(): string {
    return " * ";
  }

  get isChecked(): boolean {
    if(this.attribute && this.attribute.value) {
      return this.attribute.value.toLowerCase() == 'true';
    } else {
      return false;
    }
  }

  get isValid(): boolean {
    let requiredOpt = this.getOptionByKey(this.attribute, "required");

    if(!requiredOpt) {
      return true;
    }

    if(requiredOpt.toLowerCase() == "true" &&
        (!this.attribute.value || this.attribute.value.toLowerCase() == "false")) {
      return false
    }

    return true;
  }

  get hasChildren(): boolean {
    if(!this.attribute || !this.attribute.attributes) {
      return false;
    }

    return this.attribute.attributes.length > 0;
  }

  ngOnInit() {
    if(!this.attribute.value) {
      this.attribute.value = null
    }

    console.log("att", this.attribute)
  }

  getBooleanOptionByKey(attribute: AttributeModel, key: string): boolean {
    let optionValue = super.getOptionByKey(attribute, key)

    if(optionValue) {
      return optionValue.toLowerCase() == "true"
    }

    return false
  }

  getSizeClass(child: AttributeModel): string {
    if(!child.options) {
      return null
    }

    let size = child.options
      .find(option => option.key == "size-class")

    if(size) {
      return size.value
    }
  }

  getHideTitle() {
    console.log("att", this.attribute)
    
    let opt = this.attribute.options
        .find(option => option.key.toUpperCase() === "HIDETITLE");

    if (opt) {
        console.log("opt", opt)
        return opt.value;
    }
    else {
      console.log("opt", opt)
      return "false"
    }
  }

  getValue(): string {
    if(this.attribute.value && this.attribute.value.toLowerCase() == "true") {
      return "Sim"
    } else {
      return "Não"
    }
  }

  onValueChange(value: any) {
    if(this.attribute.attributes.length > 0) {
      this.onChangeChild(value);
    } else {
      this.onChangeDefault(value);
    }
  }

  private onChangeChild(value: any) {
    let changedChild = this.attribute.attributes
      .find(attr => attr.key == value.target.value);

    if (changedChild) {
      let checkedOpt = changedChild.options
        .find(opt => opt.key.toLowerCase() == "checked");

      if (checkedOpt) {
        checkedOpt.value = value.target.checked ? "true" : "false";
      } else {
        changedChild.options.push({
          key: "checked",
          value: value.target.checked ? "true" : "false",
          type: "Boolean"
        });
      }

      let events: DynamicEvent[] = [];
      events.push({
        attribute: changedChild
      });
      events.push({
        name: "autosave",
        data: "silently"
      });
      this.emitEvents(events);
    }
  }

  private onChangeDefault(value: any) {
    this.attribute.value = value.target.checked ? "true" : "false";

    let events: DynamicEvent[] = [];
    events.push({
      attribute: this.attribute
    });
    events.push({
      name: "autosave"
    });
    this.emitEvents(events);
  }
}
